export const basicDetail = [
  {
    name: "affiliateName",
    rule: {
      required: "Affiliate Name is required",
    },
    label: "Affiliate Name",
    type: "text",
  },
  {
    name: "affiliateCode",
    rule: {
      required: "Affiliate Code is required",
    },
    label: "Affiliate Code",
    type: "text",
  },
  {
    name: "email",
    rule: {
      required: "Email is required",
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "Invalid email address",
      },
    },
    label: "Email",
    type: "text",
  },
  {
    name: "contactNumber",
    rule: {
      required: "Contact Number is required",
    },
    label: "Contact Number",
    type: "text",
  },
  {
    name: "address",
    rule: {
      required: "Address is required",
    },
    label: "Address",
    type: "text",
  },
  {
    name: "city",
    rule: {
      required: false,
    },
    label: "City",
    type: "text",
  },
  {
    name: "province",
    rule: {
      required: false,
    },
    label: "Province",
    type: "text",
  },
  {
    name: "country",
    rule: {
      required: false,
    },
    label: "Country",
    type: "text",
  },
  {
    name: "pin",
    rule: {
      required: false,
    },
    label: "PIN/Zip Code",
    type: "text",
  },
  {
    name: "gmapLink",
    rule: {
      required: false,
    },
    label: "Google Map Link",
    type: "text",
  },
  {
    name: "commissionType",
    rule: {
      required: true,
    },
    label: "Commission Type",
    type: "dropdown",
  },
  {
    name: "commissionTypeValue",
    rule: {
      required: true,
    },
    label: "Commission Value",
    type: "number",
  },
  {
    name: "status",
    rule: {
      required: "Status is required",
    },
    label: "Status",
    type: "dropdown",
  },
];

export const commissionTypeDrop = [
  { id: "percent", name: "Percent" },
  { id: "amount", name: "Amount" },
];

export const statusDrop = [
  { id: 1, name: "Active" },
  { id: 0, name: "Inactive" },
];

export const additionalFields = [
  {
    name: "locationId",
    rule: {
      required: true,
    },
    label: "Locations",
    type: "multiselect",
  },
  {
    name: "currencyCode",
    rule: {
      required: true,
    },
    label: "Currency Code",
    type: "text",
    disabled: true,
  },
  {
    name: "networkId",
    rule: {
      required: true,
    },
    label: "Networks",
    type: "multiselect",
  },
];

export const editMode = [
  {
    name: "modTime",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Modified Time",
    type: "text",
  },
  {
    name: "modBy",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Modified By",
    type: "text",
  },
];
